module.exports = __webpack_public_path__ + "static/media/your-vote-2020-no-bg.da504ac3.png";